import React from 'react'
import classnames from 'classnames/bind'

import LabelTitleText from 'components/shared/LabelTitleText'
import Triangle from 'components/shared/Triangle'
import Layout from 'components/shared/Layout'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const TitleHero = ({ decoration, className, children, ...rest }) => {
  return (
    <Layout type="maxWidth" className={css.TitleHero}>
      <Layout type="wrapper">
        <Layout type="innerWrapper">
          <LabelTitleText
            className={cx(css.hero, className)}
            titleProps={{ tag: 'h1' }}
            textProps={{ tag: 'h2' }}
            linkProps={{ size: 'small' }}
            center
            {...rest}
          />
          {children}
        </Layout>
      </Layout>
      {decoration && (
        <div className={cx(css.triangle, decoration)}>
          <Triangle
            className={cx(decoration)}
            withDots
            type={decoration === 'right' ? 'top-right' : 'bottom-left'}
          />
        </div>
      )}
    </Layout>
  )
}

export default TitleHero
